import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "close-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("svg", {
      width: "21",
      height: "21",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", { d: "M.586.586a2 2 0 000 2.828l6.757 6.758-6.586 6.585a2 2 0 102.829 2.829L10.172 13l6.299 6.299a2 2 0 102.828-2.828L13 10.17l6.47-6.47A2 2 0 0016.643.873l-6.47 6.47L3.414.586a2 2 0 00-2.828 0z" })
    ], -1 /* CACHED */)
  ]))]))
}